define([
	"./_AutoSize",
	"./PluginFactory"
], function(_AutoSize,PluginFactory) {

	return PluginFactory.declare(_AutoSize, {
		"class": "csi-button-toggle csi-toggle-group-first",
		cssValue: "FIXED_WIDTH",
		iconClass: "csiActionIcon svgIconAutosizeFixedWidth",
		pluginName: "fixedWidth",
		title: "CanvasAutosizeFixedWidth"
	});
});
